import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import router from "@/router";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    isAuthenticated: false,
    masters: {},
    productCategories: [],
    deliveryItemCategories: [],
    adsProductCategories: [],
    products: [],
    snackbar: {
      message: '',
      type: 'primary',
      isActive: false,
    },
  },
  mutations: {
    setMasters(state, payload) {
      state.masters = payload
    },
    setAdsProductCategories(state, payload) {
      state.adsProductCategories = payload
    },
    setDeliveryItemCategories(state, payload) {
      state.deliveryItemCategories = payload
    },
    setProductCategories(state, payload) {
      state.productCategories = payload
    },
    setProducts(state, payload) {
      state.products = payload
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setSnackbar(state, payload) {
      state.snackbar = payload;
      state.snackbar.isActive = true;
    },
    closeSnackbar(state) {
      state.snackbar = {message: '', color:"primary", isActive: false};
    },
  },
  actions: {
    async getMasters({commit, getters}) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/all`,
          {
            headers: {
              Authorization: `JWT ${getters.token}`,
            },
          },
        );
        commit('setMasters', response.data);
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
      }
    },
    async getAdsProductCategories({commit, getters}) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/adsproducts/categories/`,
          {
            headers: {
              Authorization: `JWT ${getters.token}`,
            },
          },
        );
        commit('setAdsProductCategories', response.data.results);
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
      }
    },
    async getDeliveryItemCategories({commit, getters}) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/categories/`,
          {
            headers: {
              Authorization: `JWT ${getters.token}`,
            },
          },
        );
        commit('setDeliveryItemCategories', response.data.results);
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
      }
    },
    async getProductCategories({commit, getters}) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/categories/`,
          {
            headers: {
              Authorization: `JWT ${getters.token}`,
            },
          },
        );
        commit('setProductCategories', response.data.results);
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
      }
    },
    async getProducts({commit, getters}) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
          {
            headers: {
              Authorization: `JWT ${getters.token}`,
            },
          },
        );
        commit('setProducts', response.data.results);
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
      }
    },
    async userLogin({ commit }, { credentials }) {
      try {
        let response = await axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/token/`,
          {'email': credentials.email, 'password':credentials.password}
        );
        commit('setToken', response.data.token);
        commit('setIsAuthenticated', true);
        this.dispatch('getMasters');
        this.dispatch('getProductCategories');
        this.dispatch('getDeliveryItemCategories');
        router.push({'name': 'Dashboard'});
      } catch(error) {
        commit('setToken', null);
        commit('setIsAuthenticated', false);
      }
    },
    userLogout({ commit }) {
        commit('setToken', null);
        commit('setIsAuthenticated', false);
        router.push({'name': 'Auth'});
    },
    setSnackbar({ commit }, {message, type}) {
      commit('setSnackbar', {message: message, type: type, isActive: true});
    },
    closeSnackbar({ commit }) {
      commit('closeSnackbar');
    },
  },
  modules: {
  },
  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    token(state) {
      return state.token;
    },
    adsProductCategories(state) {
      return state.adsProductCategories;
    },
    deliveryItemCategories(state) {
      return state.deliveryItemCategories;
    },
    productCategories(state) {
      return state.productCategories;
    },
    products(state, productcategory_id) {
      if (productcategory_id) {
        return state.products.filter(product => product.productcategory_id == productcategory_id);
      } else {
        return state.products;
      }
    },
    nameTitles() {
      return [
        {name: '様', id: '様'},
        {name: '御中', id: '御中'},
      ]
    },
    prefectures(state) {
      return 'prefectures' in state.masters ? state.masters.prefectures : [];
    },
    industryCodes(state) {
      return 'industrycodes' in state.masters ? state.masters.industrycodes : [];
    },
    billingMethods(state) {
      return 'billingmethods' in state.masters ? state.masters.billingmethods : [];
    },
    shippingMethods(state) {
      return 'shippingmethods' in state.masters ? state.masters.shippingmethods : [];
    },
    paymentTypes(state) {
      return 'paymenttypes' in state.masters ? state.masters.paymenttypes : [];
    },
    taxTypes(state) {
      return 'taxtypes' in state.masters ? state.masters.taxtypes : [];
    },
    envelopeTypes(state) {
      return 'envelopetypes' in state.masters ? state.masters.envelopetypes : [];
    },
    quotationStatus(state) {
      return 'quotationstatus' in state.masters ? state.masters.quotationstatus : [];
    },
    subscriptionStatus(state) {
      return 'subscriptionstatus' in state.masters ? state.masters.subscriptionstatus : [];
    },
    invoiceStatus(state) {
      return 'invoicestatus' in state.masters ? state.masters.invoicestatus : [];
    },
    shippingStatus(state) {
      return 'shippingstatus' in state.masters ? state.masters.shippingstatus : [];
    },
    adsQuotationStatus(state) {
      return 'adsquotationstatus' in state.masters ? state.masters.adsquotationstatus : [];
    },
    adsInvoiceStatus(state) {
      return 'adsinvoicestatus' in state.masters ? state.masters.adsinvoicestatus : [];
    },
    adsDeliveryStatus(state) {
      return 'adsdeliverystatus' in state.masters ? state.masters.adsdeliverystatus : [];
    },
    snackbar(state) {
      return state.snackbar;
    },
  },
  plugins: [createPersistedState({
      storage: window.localStorage
  })]
})
